'use client'

import { useSyncExternalStore } from 'react'

import { useAuthStore } from '@/stores/authStore'

import { readSessionUserId } from '../lib/sessionUser'

/**
 * The store says when this tab logged in or out; the cookies say which
 * account it is. Another tab shares the cookies but not the store, so a switch
 * made there is picked up when the fan comes back to this tab.
 */
const subscribe = (onChange: () => void) => {
  const unsubscribeStore = useAuthStore.subscribe(onChange)
  window.addEventListener('focus', onChange)
  document.addEventListener('visibilitychange', onChange)

  return () => {
    unsubscribeStore()
    window.removeEventListener('focus', onChange)
    document.removeEventListener('visibilitychange', onChange)
  }
}

const getSnapshot = () =>
  useAuthStore.getState().isAuthenticated ? readSessionUserId() : undefined

const getServerSnapshot = () => undefined

/**
 * Id of the signed-in account, or undefined for a guest. Every notifications
 * query is keyed by it, and the bell is keyed by it too, so a new account
 * never sees the previous one's feed, badge or stream.
 */
export function useNotificationsUserId(): string | undefined {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
